export enum MessageType {
  Broadcast = "Broadcast",
  BroadcastCreated = "BroadcastCreated",
  EvaluationAnalyzed = "EvaluationAnalyzed",
  ProgressAnalyzed = "ProgressAnalyzed",
  LearningEventUpdated = "LearningEventUpdated",
  ConversationUpdated = "ConversationUpdated",
}
type SignalRData = Broadcast | ProgressAnalyzed | EvaluationAnalyzed | LearningEventUpdated | ConversationUpdated;

export type SignalRMessage = {
  type: MessageType;
  message: SignalRData;
};

export type Broadcast = {
  message: string;
};

export type ProgressAnalyzed = {
  contentId: string | null | undefined;
};

export type EvaluationAnalyzed = {
  contentId: string | null | undefined;
};

export type LearningEventUpdated = {
  learningEventId: string | null | undefined;
};

export type ConversationUpdated = {
  conversationId: string | null | undefined;
};
